export default "__VITE_ASSET__BqWGWOZi__"